import apiConfig from "src/utils/apiConfig";

export const GET_DRIVER = "driverdetails/fetchDriverListRequest";


export const GetDriverDetails = () => {
  const apiObject: any = {
    method: 'GET',
    authentication: true,
    endpoint: apiConfig.GETDRIVER,
  };
  return {
    type: GET_DRIVER,
    payload: apiObject,
  };
};